import { memo } from 'react';

import { VisuallyHidden } from '@air/primitive-visually-hidden';

import { workspaceAgentPanelPill } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentPanelPillChrome';

export type WorkspaceAgentPendingPillProps = {
  /** Visible only; the loading message is what gets announced. */
  label?: string;
};

/**
 * Holds the resolved chip's box so the line does not reflow. No role of its own: the message it sits
 * in is already a `log` region, and a status per chip would announce a long history many times over.
 */
export const WorkspaceAgentPendingPill = memo(({ label = 'Reference' }: WorkspaceAgentPendingPillProps) => (
  <span className={workspaceAgentPanelPill()} data-testid="WORKSPACE_AGENT_MESSAGE_PENDING_PILL">
    <VisuallyHidden>Loading {label.toLowerCase()}</VisuallyHidden>
    <span
      aria-hidden
      className="size-3 shrink-0 animate-pulse rounded-2 ads:bg-ads-gray-4 bg-gray-4 motion-reduce:animate-none"
    />
    <span aria-hidden className="truncate">
      {label}
    </span>
  </span>
));

WorkspaceAgentPendingPill.displayName = 'WorkspaceAgentPendingPill';
